import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'

class ModalDuplicateTraineeWarning extends Component {

  render() {
    const { show, onClose, duplicates, positiveCallback } = this.props
    return (
      <Modal size={ 'mini' } dimmer={ 'inverted' } open={ show } onClose={ () => onClose() }>
        <Modal.Header>Duplicate Trainee</Modal.Header>
        <Modal.Content>
        <div class="ui negative message">
          <div class="header">
            Warning
          </div>
          <p> {duplicates.length > 1 ? "Trainees" : "A trainee"} with the same full name or email {duplicates.length > 1 ? "are" : "is"} already in the system. Trainee{duplicates.length > 1 ? "s" : ""} listed below.</p>
        </div>
        <div>
          { duplicates.map((duplicate) => {
              return (
              <div>
                <p>Name: {duplicate.fullname}</p>
                <p>Email: {duplicate.email}</p>
                <hr/>
              </div>)
            })
          }
        <p>You can find them by searching their name or email in the All Trainees section.</p>
        </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            content="Cancel"
            onClick={ () => onClose() }
          />
          <Button
            negative
            content={"Add Duplicate"}
            onClick={ () => positiveCallback() }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ModalDuplicateTraineeWarning;



// WEBPACK FOOTER //
// ./src/views/components/modals/duplicate_trainee_warning.js